import React, { useState, useEffect, useCallback, useRef } from "react"
import { Link } from "gatsby"

const Navi = () => {
  const naviContent = [
    { to: '/manual/quick', label: 'クイックスタートガイド' },
    { to: '/category/parts', label: '日報の部品' },
    { to: '/manual/analytics/', label: '日報の集計' },
    { to: '/manual/pdf', label: 'PDF出力' },
    { to: '/category/news', label: 'お知らせ' },
    { to: '/inquery', label: "お問い合わせ" },
    { to: '/system/price/', label: '料金'}
  ]
  /**
   * スマホサイズ。ハンバーガーメニューのクリック状況保持
   */
  const [isExpanded, toggleExpansion] = useState(false);
  /**
   * ヘッダーナビの表示非表示切り替え
   */
  const [hideDisplay, setHideDisplay] = useState(false);
  // スクロール多発防止用フラグ
  const isRunning = useRef(false)
  const lastPos = useRef(0)

  const isScrollToggle = () => {
    if (isRunning.current) return
    isRunning.current = true
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    if (scrollTop === 0) {
      setHideDisplay(false)
    }
    requestAnimationFrame(() => {
      setHideDisplay(scrollTop > lastPos.current)
      lastPos.current = scrollTop
      isRunning.current = false
    })
  }
  // 登録と後始末
  useEffect(() => {
    document.addEventListener('scroll', isScrollToggle, { passive: true })
    return () => {
      document.removeEventListener('scroll', isScrollToggle)
    }
  }, [hideDisplay])
  return (
    <span className={`fixed top-0 left-0 w-full z-50 ${hideDisplay ? 'hidden' : 'display'}`}>
      <nav className={`flex items-center justify-between flex-wrap bg-green-700 p-6`}>
        <div className="flex items-center flex-shrink-0 text-white mr-6">
          <Link to="/" className="inline">
            <svg className="fill-current h-8 w-8 mr-2 inline" width="54" height="54" viewBox="0 0 512 512"><path d="M454,99.1q-27.59-22.62-69.72-22.63-20.26,0-45.3,5.72c.3-3.5-1.51-7.08-3.49-9.29-3.38-3.76-8-4.39-11.41-4.8-12.73-1.53-22.57,6-23.4,6.6-5.09,4-8.39,9-12,18.61-.64,1.73-1.24,3.4-1.81,5q-46.53,18.11-78.41,45.05-20.68,17-20.68,38.17,0,7.62,3.63,12.59c5.48,7.49,15.29,8.53,20.89,9.09,20.57,2.09,37.82-9.43,44.58-14.52C254,209.64,243.87,285.13,241,347c0,0-.68,14.92,1.32,43.46q-5.17-1-16.69-20.38-23.93-40.9-45.08-100.83-4.31-13.32-33.69-106.53-7.07-26.62-14.9-53.26Q121,81.4,96.29,81.4q-11.37,0-20,14.74Q70,108,61.42,136.57,45.73,190.78,45.74,296.84q0,67.53,9.41,117,7.05,39.48,22.34,39.48,7.83,0,12.53-10a41.27,41.27,0,0,0,4.31-21.88q-1.58-22.35-1.56-55.64,0-86.55,7-127,4.31-20.92,8.23-20.93t12.15,19.5s9.47,26.64,54.08,120.8c23.63,49.87,64.53,103.45,83.16,97,1.56.27,3.37-.69,6.91-2.64,3.06-1.68,21.09-13.57,23-27.81q.38-2.82-2.3-9.43a36.25,36.25,0,0,1-2.68-12.72q1.14-45.71,11.1-129.13Q303.81,179.7,313,160.37q13-10.37,40.61-18.86,25.27-7.06,41-7.07,46,0,46,39.59,0,25.93-26.81,59.86a250,250,0,0,1-54,51.37q-31.8,22.62-46.73,21.21-8.82-.95-8.81,7.07t13.79,8q6.9,0,30.26-7.54,55.93-18.39,95.38-54.2,44.06-39.59,44.06-82Q487.68,126.44,454,99.1Z" /></svg>
            <span className="font-semibold text-xl tracking-tight">クラウド日報 Nipo</span>
          </Link>
        </div>
        <div className="block md:hidden">
          <button onClick={() => toggleExpansion(!isExpanded)} className="flex items-center px-3 py-2 border rounded text-teal-200 border-teal-400 hover:text-white hover:border-white">
            <svg className="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
          </button>
        </div>
        <div className={`${ isExpanded ? `block` : `hidden` } w-full block flex-grow md:flex md:items-center md:w-auto`}>
          <div className="text-md lg:flex-grow">
            {
              naviContent.map(i => (
                <Link key={i.to} to={i.to} className="block mt-4 md:inline-block md:mt-0 text-white mr-4" activeClassName="border-b-2 font-bold">
                  {i.label}
                </Link>
              ))
            }
          </div>
          <div>
            <a href="https://nipoapp.sndbox.jp" rel="noopener noreferrer" target="_blank" className="inline-block text-sm px-4 py-2 leading-none border rounded text-white border-white hover:border-transparent hover:text-black hover:bg-green-100 mt-4 md:mt-0">Nipoを起動</a>
          </div>
        </div>
      </nav>
    </span>
  )
};
export default Navi